import React from 'react';
import { classes } from './indicators.st.css';
export const Indicators = () => /*#__PURE__*/React.createElement("div", {
  className: classes.root
}, /*#__PURE__*/React.createElement("div", {
  className: classes.indicator
}));
//# sourceMappingURL=index.js.map